export default __webpack_public_path__ + "static/media/ReportsPage-Header-Desktop.bd607e25.jpg";